<template>
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('reimport') }}: {{ table.name }}</h5>
                    <button type="button" class="btn-close" @click="$emit('close')" :disabled="reimporting"></button>
                </div>
                <div class="modal-body">
                    <div v-if="reimporting" class="text-center py-3">
                        <div class="spinner-border text-primary mb-2" role="status"></div>
                        <div class="text-muted">{{ $t('importing') }}...</div>
                    </div>
                    <div v-else-if="result" class="text-center py-3">
                        <i :class="result === 'success' ? 'fas fa-check-circle text-success' : 'fas fa-times-circle text-danger'" style="font-size: 32px"></i>
                        <div class="mt-2">{{ resultMessage }}</div>
                    </div>
                    <div v-else>
                        <div v-if="errorMessage" class="alert alert-danger py-2">{{ errorMessage }}</div>
                        <div class="row g-2">
                            <div class="col-md-12">
                                <label class="form-label small fw-bold">{{ $t('file') }}</label>
                                <input type="file" class="form-control form-control-sm"
                                       accept=".csv,.shp,.dbf,.shx,.prj,.cpg,.sbn,.sbx"
                                       @change="onFileSelected" multiple />
                            </div>
                            <div class="col-md-4" v-if="fileType === 'csv'">
                                <label class="form-label small fw-bold">{{ $t('delimiter') }}</label>
                                <select class="form-select form-select-sm" v-model="delimiter">
                                    <option value=";">;</option>
                                    <option value=",">,</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button v-if="result" type="button" class="btn btn-secondary" @click="$emit('close')">
                        {{ $t('close') }}
                    </button>
                    <template v-if="!reimporting && !result">
                        <button type="button" class="btn btn-secondary" @click="$emit('close')">
                            {{ $t('cancel') }}
                        </button>
                        <button type="button" class="btn btn-primary" @click="submit" :disabled="!files.length">
                            <i class="fas fa-sync-alt"></i> {{ $t('reimport') }}
                        </button>
                    </template>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show"></div>
</template>

<script>
import DataSpaceApi from '../../api/server/dataspace';

export default {
    name: 'ReimportModal',
    props: {
        table: { type: Object, required: true }
    },
    data() {
        return {
            files: [],
            delimiter: ';',
            fileType: '',
            reimporting: false,
            result: null,
            resultMessage: '',
            errorMessage: ''
        };
    },
    computed: {
        dataSpaceId() {
            return this.$route.params.id;
        }
    },
    methods: {
        onFileSelected(event) {
            this.files = Array.from(event.target.files);
            if (!this.files.length)
                return;

            var ext = this.files[0].name.split('.').pop().toLowerCase();
            this.fileType = ext === 'csv' ? 'csv' : 'shp';
        },
        async submit() {
            this.reimporting = true;
            this.result = null;
            this.errorMessage = '';

            try {
                const formData = new FormData();

                if (this.fileType === 'shp') {
                    this.files.forEach(f => formData.append('files', f));
                    await DataSpaceApi.reimportTableShp(this.dataSpaceId, this.table.name, formData);
                } else {
                    formData.append('file', this.files[0]);
                    formData.append('delimiter', this.delimiter);
                    await DataSpaceApi.reimportTable(this.dataSpaceId, this.table.name, formData);
                }

                this.result = 'success';
                this.resultMessage = this.$t('reimportSuccessful');
            } catch (error) {
                this.result = 'error';
                var key = error?.response?.body?.message || 'unknownError';
                this.resultMessage = this.$t(key);
            } finally {
                this.reimporting = false;
                this.$emit('reload');
            }
        }
    }
};
</script>